// AUTO-GENERATED GraphQL Builder for AuthUser
import * as Builders from '../';
export class AuthUserBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  id(){ return this.add('id'); }
  email(){ return this.add('email'); }
  name(){ return this.add('name'); }
}
